module.exports = __webpack_public_path__ + "img/lock.1c126a7d.svg";